import { Grid, IconButton } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

export const renderConfigurations = (row, options = {}) => {
  if (!row) return null;

  // Handle object-based otherNotes
  const hasOtherNotes =
    row?.otherNotes &&
    typeof row.otherNotes === "object" &&
    Object.keys(row.otherNotes).length > 0;

  if (!hasOtherNotes) return null;

  const {
    showHeader = true,
    gridMd = 6,
    gridXs = 12,
    editable = false,
    pathname = "",
    myProfile = null,
    handleAddInfo = null,
    onDeleteConfig = null,
  } = options;

  const isShoppingList = pathname === "/shopping-list";
  const isDisabled =
    myProfile?.profileInfo?.role === "ServiceTechnician" && !row?.isPermission;

  return (
    <div className="config-display-section">
      {/* LOOP OVER OBJECT KEYS */}
      {Object.entries(row.otherNotes).map(([groupKey, configs]) => {
        if (!Array.isArray(configs) || configs.length === 0) return null;
        return (
          <div key={groupKey} className="config-group-wrapper">
            {showHeader && !isShoppingList && (
              <div className="requiredINfoClass">
                <div className="requiredINfo">Required information</div>
                <span className="imp">*</span>
              </div>
            )}
            <div key={groupKey} className="config-group">
              {/* Optional: show group/user name */}
              {/* <div className="config-group-title">{groupKey}</div> */}

              {configs.map((config, cIdx) => {
                if (!config) return null;

                const fields = Array.isArray(config.fields)
                  ? config.fields
                  : [];

                const configLabel =
                  config.label || `Configuration ${cIdx + 1}`;

                return (
                  <div
                    key={`${groupKey}-${configLabel}-${cIdx}`}
                    className="config-display-card"
                  >
                    <div className="config-display-card-title" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                      {configLabel}
                      {onDeleteConfig && (
                        <IconButton
                          size="small"
                          onClick={() => onDeleteConfig(groupKey, cIdx)}
                          aria-label="Delete configuration"
                          style={{ color: "#d32f2f" }}
                        >
                          <DeleteOutlineIcon fontSize="small" sx={{ marginRight: '0px !important' }} />
                        </IconButton>
                      )}
                    </div>

                    <Grid
                      container
                      style={{ paddingLeft: "5px", textAlign: "left" }}
                      spacing={1}
                    >
                      <Grid container style={{ marginTop: "3px", alignItems: "flex-end" }} spacing={1}>
                        {fields.map((field, fIdx) => {
                          if (!field) return null;

                          // EDIT MODE
                          if (editable) {
                            return (
                              <Grid item md={gridMd} xs={gridXs} key={fIdx} style={{ display: "flex", flexDirection: "column" }}>
                                {!isShoppingList && (
                                  <div className="labelPartDetail config-field-label">
                                    {field.title || "-"}
                                    <span className="red">*</span>
                                  </div>
                                )}

                                <input
                                  className="InputFieldShippingAddressPayment shoppingListInput addRed"
                                  placeholder={field.title || ""}
                                  disabled={isDisabled}
                                  value={field.value ?? ""}
                                  onChange={(e) => {
                                    handleAddInfo?.(
                                      row,
                                      field,
                                      e.target.value,
                                      groupKey,   // IMPORTANT FIX
                                      cIdx,       // config index
                                      fIdx        // field index
                                    );
                                  }}
                                />
                              </Grid>
                            );
                          }

                          // READ MODE
                          return (
                            <Grid item md={gridMd} xs={gridXs} key={fIdx} style={{ display: "flex", flexDirection: "column" }}>
                              <div className="labelPartDetail config-field-label">
                                {field.title || "-"}
                              </div>
                              <div className="config-display-value">
                                {field.value || "-"}
                              </div>
                            </Grid>
                          );
                        })}
                      </Grid>
                    </Grid>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};

const ConfigurationDisplay = (props) => {
  return renderConfigurations(props.row, props);
};

export default ConfigurationDisplay;